const SubAbas = [
  { label: 'Produtos Farmacêuticos', rota: '/daf/produtosdaf/produtos' },
  { label: 'Denominações Genéricas', rota: '/daf/produtosdaf/denominacoes' },
  { label: 'Kits de Produtos', rota: '/daf/produtosdaf/kits' },
  { label: 'MedSUS', rota: '/daf/produtosdaf/medsus' },
  // { label: 'PDPs', rota: '/daf/produtosdaf/pdps' },
];

export default SubAbas;
